import React, { useEffect, useState } from 'react'
import Toast from '../../../helpers/Toast';
import TableComponent, { OperationsCell } from "../../TableComponent";
import { FormattedMessage } from 'react-intl';
import { ClientService } from '../../../services/ClientService';
import { EquipmentDTO } from '../../../models/Equipment/EquipmentDTO';
import { GetEquipmentsFromClientDTO } from '../../../models/Client/GetEquipmentsFromClientDTO';
import { Row } from "reactstrap";
import { useParams } from "react-router-dom";

function EquipmentsFromClientB() {
    const { id } = useParams<{ id: string }>();
    const clientService = new ClientService();
    const [equipments, setEquipments] = useState<EquipmentDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.CarPlate" />,
                accessor: "carPlate",
                width: 30,
            },
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.SerialNumber" />,
                accessor: "serialNumber",
                width: 30,
            },
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.Brand" />,
                accessor: "brand",
                width: 30,
            },
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.Model" />,
                accessor: "model",
                width: 30,
            },
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) =>
                    OperationsCell(props.cell.row.original.erpId, "equipment"),

            },
        ],
        []
    );

    const GetEquipments = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetEquipmentsFromClientDTO = {
            ErpId: id!,
            CurrentPage: currentPage,
            PageSize: pageSize,
        }
        var response = await clientService.GetPaginatedEquipmentsFromClient(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setEquipments(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(() => {
        if (id !== '') {
            GetEquipments(currentPage ?? 1, pageSize ?? 5)
        }
    }, [id, currentPage, pageSize])

    return (
        <div>
            <TableComponent
                columns={columns}
                data={equipments}
                goToPage={goToPage}
                initialPage={currentPage}
                pageCount={pageCount}
                initialPageSize={pageSize}
                pageSizes={pageSizes}
                manualPagination={true}
                loading={isLoading}
                fetchData={GetEquipments}
                initialSortBy={[]}
                disableSortBy={true}
                dontOrderFirstCollumn={true}
            />
        </div>

    )
}

export default EquipmentsFromClientB